export const useLyberBlogSeo = (article) => {
  const seo = article.attributes.seo
  const config = useRuntimeConfig().public
  const assetsUrl = config.assetsUrl
  const siteUrl = config.siteUrl

  const ogTitle = seo?.metaTitle || article.attributes.title
  const ogDescription = seo?.metaDescription
  const ogImage = seo?.metaImage?.data ? `${assetsUrl + seo?.metaImage?.data.attributes.url}` : ''
  const ogImageWidth = seo?.metaImage?.data?.attributes?.width
  const ogImageHeight = seo?.metaImage?.data?.attributes?.height
  const ogUrl = siteUrl + '/blog/articles/' + article.attributes.slug + '/'
  const tag = article.attributes.tag?.attributes?.name

  useSeoMeta({
    title: ogTitle,
    ogTitle: ogTitle,
    description: ogDescription,
    ogDescription: ogDescription,
    ogImage: ogImage,
    keywords: seo?.keywords,
    ogImageWidth,
    ogImageHeight,
    ogUrl,
    ogType: 'article',
    author: 'Lyber'
  })
  useHead({
    meta: [
      { property: "article:published_time", content: article.attributes.updatedAt },
      { property: "og:updated_time", content: article.attributes.updatedAt },
      { name: "keywords", content: tag },
      { property: "article:tag", content: tag },
      { property: "article:author", content: 'Lyber' }
    ]
  })
}